/* eslint-disable func-names */
/* eslint-disable no-undef */
const hardWork = () => {
  (function ($) {
    const $playButton = $('.js-hard-work-button');
    const $videoEmbed = $('.js-hard-work-video');
    const $videoIframe = $('.js-hard-work-iframe');

    $playButton.on('click', () => {
      $playButton.toggle();
      $videoEmbed.toggle();

      $videoIframe.attr('src', $videoIframe.attr('src').replace('autoplay=0', 'autoplay=1'));
    });
  }(jQuery));
};

export default hardWork;
